// Sources for analytics
export const ANON_RECORD_A_REPLY = 'anon-record-a-reply';
export const ANON_CREATOR_SHARE_PAGE = 'anon-creator-share-page';
export const PRIMARY_WEB_APP = 'primary-web-app-onboarding';
